import { ReactElement, ReactNode, useId } from "react";
import './input-checkbox.css'
import { clsx, inputOnKeyUp } from "../../functions.ts";

export default function InputCheckbox (props: {
	label: string,
	value: boolean,
  infoButton?: ReactNode,
  onChange: (value: boolean) => void,
}){
  const id = useId();
  return <div className={"input input-checkbox"}>
        <label className={"input__label"} id={id+"-label"}></label>
        <div tabIndex={0} role="checkbox" aria-checked={props.value} aria-labelledby={id+"-label"} className="input-checkbox__container"
         onClick={()=>{props.onChange(!(props.value || false))}}
         onKeyUp={(event)=>inputOnKeyUp(event, ()=>{props.onChange(!(props.value || false))})}
         >
          <div aria-hidden className={clsx("input-checkbox__box", props.value && "input-checkbox__box--active")}>
          {/* <input inert className={"input-checkbox__input input"} id={id} type="checkbox" checked={props.value || false}/> */}
          </div>
          <div className={"input-checkbox__label"}>
            <label htmlFor={id} dangerouslySetInnerHTML={{__html:props.label}}></label>
          </div>
        </div>
        {props.infoButton}
    </div>
}
